/**
 * Marketing attribution -> cart (task #1118).
 *
 * titan-web / Drupal / this theme write the _img_marketing_params cookie on
 * .imgacademy.com: every UTM and ad click-id, one "session_N" object per
 * param-bearing visit, encodeURIComponent(JSON.stringify(sessions)). This
 * file is the READER: it copies the cookie's JSON onto the cart as ONE
 * top-level attribute, marketing_params, so Shopify carries it to the order
 * (Additional details / note_attributes). The customer / participants
 * attributes - and their marketing_data - are not touched.
 *
 * SITEWIDE ON PURPOSE: every purchase path passes a page on this domain
 * (the camp selector, share carts, /pages/router, /pages/personal-coach,
 * /pages/add-to-cart, product pages, /cart), so one reader covers all carts.
 * Loaded by layout/theme.liquid AND by every {% layout none %} purchase page.
 *
 * Writes only when the cart's value differs from the cookie: one GET /cart.js
 * per page view, and a cart/update.js carrying marketing_params alone.
 * cart/update.js replaces only the attributes it names, so customer /
 * participants written by other scripts are left as they are.
 *
 * Two cookie rules from the writer's contract (MARKETING_PARAMS_HANDOFF):
 *  - split document.cookie BEFORE decoding: a value may hold an encoded ; or ,
 *  - decode the value exactly ONCE: click-ids stay single-encoded.
 *
 * window.imgMarketingParams.sync() returns a Promise, for pages that leave
 * for /checkout right after writing the cart; syncWithin(ms) is the same but
 * settles after ms at the latest, so a slow request never holds a shopper up
 * (add-to-cart.js, router.js - the routes that skip the /cart page).
 */
(function () {
  var COOKIE = '_img_marketing_params';
  var ATTRIBUTE = 'marketing_params';
  var pending = null;

  /**
   * The cookie's sessions object, or null when absent or unreadable.
   * Mirrors readSessions() in titan-web marketing-params.client.ts.
   */
  function readSessions() {
    var parts = (document.cookie || '').split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].replace(/^\s+/, '');
      if (part.indexOf(COOKIE + '=') !== 0) {
        continue;
      }
      var raw = part.substring(COOKIE.length + 1);
      if (!raw) {
        return null;
      }
      try {
        var value = JSON.parse(decodeURIComponent(raw));
        if (value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length) {
          return value;
        }
      } catch (e) {
        console.warn('[marketing_params] unreadable cookie, skipped', e);
      }
      return null;
    }
    return null;
  }

  function sync() {
    if (pending) {
      return pending;
    }
    var sessions = readSessions();
    if (!sessions || !window.fetch) {
      return Promise.resolve(false);
    }
    var value = JSON.stringify(sessions);

    pending = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        var current = cart && cart.attributes ? cart.attributes[ATTRIBUTE] : null;
        if (current === value) {
          return false;
        }
        var attributes = {};
        attributes[ATTRIBUTE] = value;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).then(function (res) { return res.ok; });
      })
      .catch(function (e) {
        // Attribution must never get in the way of a purchase.
        console.warn('[marketing_params] cart write failed', e);
        return false;
      })
      .then(function (written) {
        pending = null;
        return written;
      });

    return pending;
  }

  function syncWithin(ms) {
    return new Promise(function (resolve) {
      var timer = setTimeout(function () { resolve(false); }, ms);
      sync().then(function (written) {
        clearTimeout(timer);
        resolve(written);
      });
    });
  }

  window.imgMarketingParams = { read: readSessions, sync: sync, syncWithin: syncWithin };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
